import { PLAN_LABELS } from '@gl/shared';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useCurrentLocal } from '@/lib/local-context';

/** Placeholder: todavía no hay cobros (Mercado Pago queda para después del MVP). */
export function SuscripcionPage() {
  const local = useCurrentLocal();
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          Tu plan <Badge>{PLAN_LABELS[local.plan]}</Badge>
        </CardTitle>
        <CardDescription>Por ahora todas las funciones están habilitadas sin costo.</CardDescription>
      </CardHeader>
      <CardContent className="text-sm text-muted-foreground">
        Pronto vas a poder elegir un plan y pagar con Mercado Pago desde acá. Si tenés dudas, escribinos.
      </CardContent>
    </Card>
  );
}
